import { Injectable } from '@angular/core';
import { CustomerStoreService } from '@app/ngrx-customer/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ORDER_ACTIONS } from '@order/actions/order-actions';
import { OrderDownloadService } from '@shared/services/file-download/order-download.service';
import { combineLatest, mergeMap, of, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MyOrdersEffects {
  downloadOrderStatusOrders$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ORDER_ACTIONS.downloadOrderStatus),
        mergeMap(payload =>
          combineLatest([
            of(payload),
            this.customerStoreService.loadCustomers$(),
          ]).pipe(take(1)),
        ),
        tap(([{ orders, fileName, fileType }, customers]) => {
          this.orderDownloadService.downloadAndOpenOrder(orders, {
            fileName,
            fileType,
            customers,
            myOrdersFormat: true,
            successToast: 'i18n.orderPage.ordersDownloadSuccess',
            failToast: 'i18n.orderPage.ordersDownloadFail',
          });
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private customerStoreService: CustomerStoreService,
    private orderDownloadService: OrderDownloadService,
  ) {}
}
